import { Reducer } from "redux";
import {
  ACTION,
  RequestAiAssistantRun,
  FailAiAssistantRun,
  FinishAiAssistantRun,
  ReceiveDraftConfirmation,
  FailCreateDraft
} from "./action-types";
import { AiChatAssistantState, INITIAL_STATE } from "./types";

interface ActionMap {
  [indexer: string]: Reducer<AiChatAssistantState>;
}

const reducers: ActionMap = {
  [ACTION.REQUEST_RUN]: (state: AiChatAssistantState, action: RequestAiAssistantRun): AiChatAssistantState => {
    return {
      ...state,
      running: true,
      previousError: undefined,
      hasConfirmedDraft: false
    };
  },

  [ACTION.FAIL_RUN]: (state: AiChatAssistantState, action: FailAiAssistantRun): AiChatAssistantState => {
    return {
      ...state,
      running: false,
      previousError: action.errorMessage
    };
  },

  [ACTION.FINISH_RUN]: (state: AiChatAssistantState, action: FinishAiAssistantRun): AiChatAssistantState => {
    return {
      ...state,
      running: false
    };
  },

  [ACTION.RECEIVE_DRAFT_CONFIRMATION]: (state: AiChatAssistantState, action: ReceiveDraftConfirmation): AiChatAssistantState => {
    return {
      ...state,
      hasConfirmedDraft: true
    };
  },

  [ACTION.REQUEST_CREATE_DRAFT]: (state: AiChatAssistantState): AiChatAssistantState => {
    return {
      ...state,
      draftError: undefined,
      createDraft: true
    };
  },

  [ACTION.FINISH_CREATE_DRAFT]: (state: AiChatAssistantState): AiChatAssistantState => {
    return {
      ...state,
      createDraft: false
    };
  },

  [ACTION.FAIL_CREATE_DRAFT]: (state: AiChatAssistantState, action: FailCreateDraft): AiChatAssistantState => {
    return {
      ...state,
      draftError: action.errorMessage
    };
  }
};

export const reducer: Reducer<AiChatAssistantState> = (
  state: AiChatAssistantState = INITIAL_STATE,
  action: any
) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
